import { i18n } from '../../ol-street-view';

export const es: i18n = {
    exit: 'Salir',
    exitView: 'Salir de la vista Street View',
    dragToInit: 'Arrastre y suelte para iniciar Google Street View',
    noImages: 'Sin imágenes en la zona. Click en el mapa para trasladarse',
    termsOfService: 'Condiciones del Servicio',
    expand: 'Expandir',
    minimize: 'Minimizar'
};
